const MM_BREADCRUMB_KEY = 'mm_last_collection';

// Sur une page collection : stocke le contexte via le data-attribute du breadcrumb
const colData = document.querySelector('[data-mm-breadcrumb-collection]');
if (colData) {
  localStorage.setItem(MM_BREADCRUMB_KEY, JSON.stringify({
    url: colData.dataset.mmBreadcrumbCollectionUrl,
    title: colData.dataset.mmBreadcrumbCollectionTitle
  }));
}

// Sur une page produit : injecte la collection depuis le localStorage si disponible
const productLink = document.querySelector('.mm-col-fil-pp');
if (productLink) {
  const stored = localStorage.getItem(MM_BREADCRUMB_KEY);
  if (stored) {
    try {
      const { url, title } = JSON.parse(stored);
      if (url && title) {
        productLink.href = url;
        const textEl = productLink.querySelector('.mm-btn-text');
        if (textEl) textEl.textContent = title;
      }
    } catch (e) {
      localStorage.removeItem(MM_BREADCRUMB_KEY);
    }
  }
}
